import { createFileRoute, redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { setCookie } from "@tanstack/react-start/server";

const logout = createServerFn().handler(async () => {
	setCookie("session", "", { maxAge: 0, path: "/" });
});

export const Route = createFileRoute("/auth/logout")({
	component: () => null,
	async loader() {
		await logout();

		throw redirect({ to: "/auth/login" });
	},
});
